<template>
    <layout-general-container spaceToolbar>
        <div class="w-full flex justify-center">
            <div class="w-full flex flex-col gap-10">
                <div
                    class="bg-banner-1 h-[40vh] border-b px-6 flex flex-col gap-8 items-center justify-center text-center w-full">
                    <h1 class="text-white text-4xl font-semibold tracking-wide">Our Program</h1>
                    <h2 class="text-white tracking-wide leading-loose md:max-w-6xl font-light">Instellar partners with visionary organizations to create impactful and tailor-made programs by utilizing our expertise in incubation, acceleration, strategic planning, and investment readiness.</h2>
                </div>
                <div class="w-full px-6 md:px-8 xl:px-14 flex-col flex gap-8 bg-white">
                    <div class="w-full flex flex-col md:flex-row justify-end gap-6">
                        <div class="flex flex-col md:flex-row gap-2 md:items-center">
                            <span class="text-sm text-light font-medium min-w-max">Status :</span>
                            <a-select placeholder="Select" class="w-full md:w-[12rem]" @change="onChangeStatus" id="program-filter-status">
                                <a-select-option value="Upcoming">Upcoming</a-select-option>
                                <a-select-option value="Ongoing">Ongoing</a-select-option>
                                <a-select-option value="Ended">Ended</a-select-option>
                            </a-select>
                        </div>
                        <div class="flex flex-col md:flex-row  gap-2 md:items-center">
                            <span class="text-sm text-light font-medium min-w-max">Type :</span>
                            <a-select placeholder="Select" class="w-full md:w-[12rem]" @change="onChangeType" id="program-filter-type">
                                <a-select-option value="Accelerator">Acceleration</a-select-option>
                                <a-select-option value="Incubator">Incubation</a-select-option>
                            </a-select>
                        </div>
                    </div>
                    <div class="w-full gap-6 grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3" v-if="programs.length > 0">
                        <card-program v-for="item in programs" :tag="'btn-apply-list-'+item.slug" :enrolled="['Enrolled', 'Completed'].includes(item.isEnrolled)" :statusEnrolled="item.isEnrolled" :discovery="true" :key="item.id" :name="item.title"
                            :id="item.id" :slug="item.slug" :image="item.photo" :type="item.type" :description="item.short_desc"
                            :status="item.status" :date="moment(item.start_date).format('MMM DD, YYYY')" :batch="item.batch" :isOpen="item.isOpen" />
                    </div>
                    <div class="w-full gap-6 flex justify-center" v-else>
                        <span class="text-sm text-gray-500 text-center">
                            No Program Found.
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </layout-general-container>
</template>
  
<script setup>
    import { ref, onMounted } from 'vue'
    import axios from "@/plugins/axios";
    import { IconArrowRight, IconSearch, IconSortDescending, IconCategory2, IconChartDonut, IconCalendarMonth, IconTrophy, IconAlarm, IconHourglassEmpty, IconCertificate2, IconRotateClockwise2 } from '@tabler/icons-vue'
    import moment from 'moment';

    const programs = ref([])
    const status = ref('')
    const type = ref('')

    const fetchPrograms = async () => {
        try {
            const response = await axios.get('/program', {
                params: {
                    status: status.value,
                    type: type.value,
                }
            })

            programs.value = response?.data?.data
        } catch (error) {
            console.error('Error fetching programs:', error)
        }
    }

    const onChangeStatus = (value) => {
        status.value = value
        fetchPrograms()
    }

    const onChangeType = (value) => {
        type.value = value
        fetchPrograms()
    }

    onMounted(fetchPrograms)
</script>
  